var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    className: "sc-afa16384-1 TDXzR",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m12.777 2.66.127.075.126.09 8.678 7.066c.447.37.616.961.426 1.495a1.41 1.41 0 0 1-1 .888l-.142.027h-.095v7.024c0 .666-.494 1.227-1.16 1.35l-.135.02-.135.005H4.744c-.693 0-1.277-.475-1.405-1.115l-.02-.13-.006-.13.048-7.015a1.422 1.422 0 0 1-1.284-.928 1.33 1.33 0 0 1 .227-1.292l.095-.106.104-.094 8.678-7.065a1.477 1.477 0 0 1 1.596-.164Zm.71 12.646h-2.812v4.024l2.86.05v-4.024l-.049-.05ZM12.73 4.442a1 1 0 0 0-1.252-.001l-8.05 6.45h1.366l-.044 7.394a1 1 0 0 0 .99 1.006l3.554.04v-3.975c0-.666.495-1.227 1.16-1.35l.136-.019.135-.006h2.76c.693 0 1.277.475 1.405 1.115l.02.13.006.13v3.924h3.507a1 1 0 0 0 1-.994l.044-7.396h1.285L12.73 4.442Z",
    fill: "#777777"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.09b5cf20385b6e6814683c997ac7fbae.svg";
export { ForwardRef as ReactComponent };